

import * as actionTypes from '../actions';
import store from 'store';
import { architeckCall } from 'database';

export const updateProjects = (objects) => {

    let objectToUpdate = objects

    // //if no array is sent create an array out of single _id sent
    if(!(objects instanceof Array)) {
        objectToUpdate = [objects]
    }

    let newStateToSet = [...store.getState().projects.app_projects]

    objectToUpdate.forEach(u => {

        newStateToSet[newStateToSet.findIndex(el => el._id === u._id)] = u;

    })

    dispatchActions(newStateToSet)
    
}

export const removeProjects = (_ids) => {

    let objectToRemove = _ids

    //if no array is sent create an array out of single _id sent
    if(!(_ids instanceof Array)) {
        objectToRemove = [_ids]
    }

    let newStateToSet = [...store.getState().projects.app_projects]

    newStateToSet = newStateToSet.filter(u => {
        return objectToRemove.includes(u._id) ? false: true
    })
   
    dispatchActions(newStateToSet)
   
}

export const addProjects = (objects) => {

    console.log(objects);
    let objectToAdd = objects

    // //if no array is sent create an array out of single _id sent
    if(!(objects instanceof Array)) {
        objectToAdd = [objects]
    }

    let newStateToSet = [...store.getState().projects.app_projects]

    objectToAdd.forEach(u => {

        newStateToSet.unshift(u);

    })

    dispatchActions(newStateToSet)
    
}

export const setAppProjects = async() => {
    return new Promise( async (resolve, reject) => {

        const users = await architeckCall({
            method: 'get',
            url: '/api/v1/projects/list?loop=true&limit=500'
        })

        if(users.success) {

            dispatchActions(users.data)

            resolve({success: true});
            return;

        } else {

            //error reporting here
            resolve({success: false, message: 'Failed to load app projects. '});
            return;

        }

    })

}

const dispatchActions = (data) => {

    store.dispatch({
        type: actionTypes.SET_APP_PROJECTS,
        payload: {
            objects: data
        }
    });

    return true;
}